<template>
  <v-card outlined tile class="py-0">
    <v-card-title class="subtitle-2 py-1 px-2 "
      ><v-icon dense :color="dotColor" class="mr-1 pl-0">
        mdi-record-circle-outline</v-icon
      >{{ title }}
    </v-card-title>

    <v-card-text
      v-if="isLoading"
      class=" pb-0 text-center title font-weight-regular"
      >{{ $Amplify.I18n.get("Loading...") }}</v-card-text
    >

    <v-card-text v-else class=" pb-0 text-center headline black--text">
      {{ before }}{{ value[propertyName] | currency("", decimalPlaces) }}
      {{ after }}
    <!--   <v-icon>mdi-swap-horizontal</v-icon> -->
    </v-card-text>

    <v-card-actions class="justify-center">
      <!-- <span class="font-weight-bold">Anterior: </span> N/D -->
      <v-simple-table dense v-if="value.buckets.length > 0 && !isLoading">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Año
              </th>
              <th class="text-left">
                {{ title }}
              </th>
              <th class="text-left">
                Anterior
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in value.buckets" :key="item.ano">
              <td>{{ item.ano }}</td>
              <td class="text-right">
                {{ item[propertyName] | currency("", decimalPlaces) }}
              </td>
              <td
                class="text-right d-flex justify-space-between"
                v-if="item[`previous_${propertyName}`] != 0"
              >
                <v-icon
                  v-if="item[`previous_${propertyName}`] > item[propertyName]"
                  dense
                  color="error"
                  >mdi-arrow-down</v-icon
                >
                <v-icon v-else dense color="success">mdi-arrow-up</v-icon>
                {{
                  item[`percent_${propertyName}`] | currency("", decimalPlaces)
                }}
                %
              </td>
              <td v-else class="text-center">
                ---
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "resume-item",
  props: {
    title: String,
    decimalPlaces: {
      type: Number,
      default: 2
    },
    value: {
      type: Object
    },
    previousTitle: String,
    dotColor: String,
    previousValue: {
      type: Number,
      default: 0
    },
    after: {
      type: String,
      default: ""
    },
    before: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    borderTop: {
      type: Boolean,
      default: true
    },
    borderRight: {
      type: Boolean,
      default: true
    },
    borderBottom: {
      type: Boolean,
      default: true
    },
    borderLeft: {
      type: Boolean,
      default: true
    },
    propertyName: {
      type: String
    }
  },
  data() {
    return {
      styleObject: {
        borderTopStyle: this.borderTop ? "solid" : "none",
        borderRightStyle: this.borderRight ? "solid" : "none",
        borderBottomStyle: this.borderBottom ? "solid" : "none",
        borderLeftStyle: this.borderLeft ? "solid" : "none"
      }
    };
  },
  methods: {}
};
</script>

<style></style>
